// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__DQorR","loadingAnimation":"loader_loadingAnimation__-3Bhv","loading":"loader_loading__cUHsG"};